import { createSelector } from 'reselect'
import { IStore } from '../index'

export const getBookingSettings = (state: IStore) => state.booking.settings
export const getBookingUser = (state: IStore) => state.booking.user
export const getBookingMapping = (state: IStore) => state.booking.mapping
export const getBookingRooms = (state: IStore) => state.booking.rooms

export const getBookingStep = (state: IStore) => state.booking.step

export const getBookingChanged = (state: IStore) => state.booking.changed

export const getBookingRoomError = (state: IStore) => state.booking.bookingError

export const getBookingTab = (state: IStore) => state.booking.tab

export const getBookingPricingInfo = (state: IStore) =>
  state.booking.pricingInfo

export const getBookingPropertyCheckLoading = (state: IStore) =>
  state.booking.propertyCheckLoading

export const getTroubledBookingRooms = (state: IStore) =>
  state.booking.troubledRooms

export const getBookingPropertyIsTaken = (state: IStore) =>
  state.booking.isTaken

export const getBookingRoomsMapped = createSelector(
  [getBookingRooms, getBookingMapping],
  (rooms, mapping) => {
    return (
      rooms &&
      rooms.filter(r => {
        if (mapping) {
          return (
            !!mapping.find(m => m.booking_id === r.id) &&
            mapping.find(m => m.booking_id === r.id).bed_booking_rooms.length >
              0
          )
        } else {
          return undefined
        }
      })
    )
  },
)


export const getBookingObjects = (state: IStore) => state.booking.bookingObjects

export const getBookingRoomsPricing = createSelector([getBookingObjects], objects => {
  const rooms = objects.reduce((acc, obj) => acc.concat(obj.rooms), [])
  return rooms.reduce((acc, room) => acc.concat(room.pricing), [])
})

/** Pricing tylko dla pokoju (bed room) – po mapowaniu booking_id → bed_booking_rooms */
export function getBookingPricingForBedRoom(state: IStore, bedRoomId: string | number): any[] {
  const objects = getBookingObjects(state) || []
  for (const obj of objects) {
    const mappings = obj.mappings || []
    const mapping = mappings.find((m: any) =>
      (m.bed_booking_rooms || []).some((id: any) => String(id) === String(bedRoomId))
    )
    if (mapping) {
      const room = (obj.rooms || []).find((r: any) => String(r.id) === String(mapping.booking_id))
      return room?.pricing ?? []
    }
  }
  return []
}

export const getBookingObjectsLoading = (state: IStore) => state.booking.loading

export const getBookingCurrency = (state: IStore) =>
  state.booking.settings.booking_currency


export const selectBookingObjects = (state) => state.booking.bookingObjects;
export const selectAirBnbListings = (state) => state.integration.listings;

export const selectBookingRooms = createSelector(
  [selectBookingObjects],
  (bookingObjects) => bookingObjects.reduce((acc, obj) => acc.concat(obj.rooms), [])
);

export const selectBookingMapping = createSelector(
  [selectBookingObjects],
  (bookingObjects) => bookingObjects.reduce((acc, obj) => acc.concat(obj.mappings), [])
);

export const selectFullMappings = createSelector(
  [selectBookingMapping, selectBookingRooms],
  (bookingMapping, bookingRooms) =>
    bookingMapping.map((mapping) => ({
      ...mapping,
      room: bookingRooms.find((room) => room.id === mapping.booking_id),
    }))
);
